<template>
  <v-layout class="patient-page" column>
  

      <v-card flat class="ma-2 mt-4">
        <v-layout row>
          <span class="headerTabUnselected" @click="adminHome()">Admin</span><span class="headerTabSelected">Providers</span>
        </v-layout>

    <v-text-field hide-details solo flat background-color="transparent" class="search-field mt-3 mb-4"
           v-model="search" prepend-icon="search" label='Search by provider ID, last name, org name, zip code' single-line></v-text-field>
        


        <v-data-table
          :headers="headers"
          :items="providerSearchResults"
          sort-icon=""
          class="flat mb-2 table-border"
          :rows-per-page-items="[15,{text: 'All', value:-1}]"
          :search="search"
          color="#eeeeee"
        >
        <v-progress-linear v-show="!providerSearchResults" slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr style="cursor:pointer" @click="props.expanded = !props.expanded">
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td> {{ formatNPI(props.item) }}</td>
              <td class="text-xs-left">{{ formatProviderName(props.item) }}</td>
              <td class="text-xs-left">{{ formatOrgName(props.item) }}</td>
              <td class="text-xs-left">{{ formatZip(props.item) }}</td>
            </tr>
          </template>

          <template slot="expand" slot-scope="props">
            <v-card flat>
              <v-toolbar dense flat color="transparent">
            <v-toolbar-title>{{ formatProviderNameForCard(props.item) }}</v-toolbar-title>
            
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-btn small flat icon @click="editProvider(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            </v-toolbar-items>
        </v-toolbar>
              <v-card-text>
              <v-layout column>
                <v-layout row wrap>
                <v-card flat class="ma-2">
                  <v-layout column>
                  <span>Address</span>
                  <span>{{providerDisplayAddressFromProviderObject(props.item)}}</span>
                  </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Phone</span>
                  <span>{{props.item.phone}}</span>
                </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Fax</span>
                  <span>{{props.item.fax}}</span>
                </v-layout>
                </v-card>
                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Email</span>
                  <span>{{props.item.email}}</span>
                </v-layout>
                </v-card>
                </v-layout>
                                <v-card flat class="ma-2">
                <v-layout column>
                  <span>Provider Notes</span>
                  <span>{{props.item.notes}}</span>
                </v-layout>
                  </v-card>
                <v-layout row wrap>
                  <v-card flat class="ma-2">
                <v-layout row>
                  <v-layout column>
                  <span>Secure Affiliate Link</span>
                  <span>{{formatSecureAffiliateLink(props.item)}}</span>
                  </v-layout>
                  <v-spacer></v-spacer>
                  <v-btn @click="sendInviteFax(props.item)" depressed>Send Invite Fax</v-btn>
                </v-layout>
                  </v-card>
                </v-layout>
                <v-layout v-if="props.item.googlePlaceID" row wrap>
                  <v-card flat class="ma-2">
                <v-layout column>
                  <span>Google Places Link</span>
                  <a :href="formatGooglePlacesLink(props.item)" target="_blank">{{formatGooglePlacesLink(props.item)}}</a>
                </v-layout>
                  </v-card>
                </v-layout>
                <v-card flat style="opacity:0.5" class="ma-2">
                <span>{{ props.item }}</span>
                </v-card>
          
                <v-layout style="opacity:0.5; margin-top:20px;" row>
                  <v-spacer></v-spacer>{{formatOrigin(props.item)}}
                </v-layout>
              </v-layout>
                </v-card-text>
            </v-card>
          </template>

        </v-data-table>
      </v-card>

    <add-edit-provider-dialog @emitProviderUpdate="reloadOnReturn()" ref="addEditProviderDialog"/>

  </v-layout>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';


.table-border {
  border: 1px solid #f5f5f5;
}

.search-field {
  background: #f5f5f5;
  border-radius: 4px;
  padding-left: 18px;
}

.loader {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 70em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.headerTabUnselected:hover {
  opacity: 1;
}

</style>

<script>
import { mapActions, mapState } from 'vuex'
import Titlebar from '@/components/Titlebar'
import HelperMixin from '@/core/mixins/HelperMixin'
import AddEditProviderDialog from '@/components/dialogs/AddEditProviderDialog'
import bus from '@/core/helpers/bus'

export default {
  mixins: [HelperMixin],
  components: {
    Titlebar,
    AddEditProviderDialog
  },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Provider ID',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        { text: 'NPI',
          sortable: false,
          value: 'npi',
          align: 'left' },
        { text: 'Provider Name',
          sortable: true,
          value: 'lastName',
          align: 'left' },
        { text: 'Organization',
          sortable: true,
          value: 'organizationName',
          align: 'left' },
        {text: 'Zip Code',
          align: 'left',
          sortable: true,
          value: 'address.zip'
        }
      ]
    }
  },
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getProvidersList',
      'sendProviderInvite'
    ]),
    sendInviteFax(provider) {
      if (provider.fax) {
        this.sendProviderInvite({ id: provider.id }).then((response) => {
          this.toast('success', 'Fax Sent')
        })
      } else {
        this.toast('error', 'Missing Fax')
      }
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    editProvider(provider) {
      this.$refs.addEditProviderDialog.open({ id: provider.id, provider: provider })
    },
    reloadOnReturn() {
      this.providerSearchResults = null
      this.getProvidersList()
    },
    filterImagineMD() {
      this.search = '5b73507c4aef2028740f662b'
    },
    filterSmartChoice() {
      this.search = '5a4fa82c8e4b74e028665d04'
    },
    filterGrayhawk() {
      this.search = '5acb94000495d7065c909bc2'
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    formatGooglePlacesLink(item) {
      return 'https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' + item.googlePlaceID
    },
    formatSecureAffiliateLink(item) {
      return 'https://patient.onecharthealth.com/#/login?provider=' + item.id + '&affiliateCode=' + item.affiliateCode
    },
    formatCreatorEmail(item) {
      if (item.creator) {
        if (item.creator.email) {
          return item.creator.email
        } else {
          return 'No Email'
        }
      } else {
        return 'No Creator'
      }
    },
    formatNPI(item) {
      if (item.npi) {
        return item.npi
      } else {
        return '-'
      }
    },
    formatPartnerName(item) {
      console.log(item)
      if (item.partner) {
        return this.transformPartnerIDToHumanReadableName(item.partner.id)
      } else {
        return 'Consumer'
      }
    },
    formatProviderName(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName + ' ' + item.credentials
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    formatOrigin(item) {
      if (item.googlePlaceID && item.npi) {
        return 'Google Data and NPI Registry'
      }
      if (item.googlePlaceID) {
        return 'Google Data'
      } else if (item.npi) {
        return 'NPI Registry'
      } else {
        return 'Origin Unknown'
      }
    },
    formatProviderNameForCard(item) {
      if (item.lastName) {
        if (item.firstName) {
          return item.firstName + ' ' + item.lastName + ' ' + item.credentials
        } else {
          return item.lastName + ' ' + item.credentials
        }
      } else if (item.organizationName) {
        return item.organizationName
      } else if (item.googlePlaceID) {
        return item.googlePlaceID
      } else {
        return 'Missing Provider Name'
      }
    },
    formatZip(item) {
      if (item.address) {
        if (item.address.zip) {
          return item.address.zip
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    formatOrgName(item) {
      if (item.organizationName) {
        return item.organizationName
      } else {
        return '-'
      }
    },
    formatPlaceID(item) {
      if (item.googlePlaceID) {
        return 'Yes'
      } else {
        return '-'
      }
    },
    formatCreatorName(item) {
      if (item.creator) {
        if (item.creator.lastName) {
          if (item.creator.firstName) {
            return item.creator.firstName + ' ' + item.creator.lastName
          } else {
            return 'Missing Patient'
          }
        } else {
          return 'Missing patient'
        }
      }
    },
    formatDate(timestamp) {
      if (timestamp != null) {
        let d = new Date(timestamp * 1000)
        let MyDateString = ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear()
        return MyDateString
      }
      return ''
    },
    adminHome() {
      this.$router.push({
        name: 'AdminLandingPage'
      })
    }
  },
  computed: {
    ...mapState('admin', ['requests', 'patient', 'request', 'patientSearchResults', 'userSearchResults', 'providerSearchResults'])
  },
  created() {
    this.getProvidersList()
  },
  watch: {
    patientSearchResults() {
      console.log(this.patientSearchResults)
    },
    providerSearchResults() {
      console.log(this.providerSearchResults)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/AdminProvidersPage.vue